'use client'

import {useEffect} from 'react'
import {getHistoryEntryKey, observeNavigationHistory} from '@fitro/overlay-layout'
import {trackNavigationEntry} from '../lib/navigationStack'

/** Track actual browser entries, including Back/Forward and same-entry replaces. */
export const useNavigationStackTracker = () => {
    useEffect(() => {
        const stop = observeNavigationHistory(event => {
            trackNavigationEntry(event.toKey, event.toUrl, event.kind)
        })
        trackNavigationEntry(getHistoryEntryKey(), window.location.href, 'pop')
        return stop
    }, [])
}
